/**
 * @module worker/worker
 */
/**
 * @typedef {object} worker
 * @property {Worker} source The Worker
 * @property {string} uid The Worker request uid
 */
import object from '../utils/object.js'
import sharing, { release } from '../utils/sharing.js'

const { Worker } = globalThis

/**
 * Releases the Worker for the provided request uid
 * @param {Worker} source
 * @param {string} uid
 */
export { release }

/**
 * Registers an Worker request
 * @param {string} url
 * @return {worker}
 */
export default (
  url,
  { ...options } = {}
) => {
  const [uid, worker] = sharing(Worker, url, options)
  
  return object(null, { uid, worker })
}
